import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { validateEmail, getEmailErrorMessage } from '../../utils/email';
import { passwordIsValid, getPasswordErrorMessage } from '../../utils/password';
import { Input } from '../';

const responseCode = {
  userExists: 'user_exists',
  invalidPassword: 'invalid_password'
};

class SignupPane extends Component {
  state = {
    email: '',
    password: '',
    buttonIsDisabled: false,
    error: {
      email: '',
      password: ''
    }
  };

  onChange = event => {
    const keyName = event.target.name;
    const value = event.target.value;
    let newState = {};
    newState[keyName] = value;
    this.setState(newState);
  };

  onSubmitError = details => {
    let error = {};
    if (details.code === responseCode.userExists) {
      error = { email: details.description, password: '' };
    }
    if (details.code === responseCode.invalidPassword) {
      error = details.policy
        ? // Needs to change how we get the string policy. We will provide 'policy' directly in err obj in auth0.js
          // However we need to better handle the password policy error.
          { email: '', password: details.policy }
        : { email: '', password: details.description };
    }
    this.setState({ error, buttonIsDisabled: false });
  };

  submitHandler = event => {
    event.preventDefault();
    const { email, password } = this.state;
    this.submit({ email, password });
    return false;
  };

  submit = data => {
    let error = { email: '', password: '' };
    this.setState({ error, buttonIsDisabled: true });
    const { email, password } = data;
    const { onSignup } = this.props;
    const emailIsValid = validateEmail(email);
    if (emailIsValid && passwordIsValid(password)) {
      onSignup(email, password, this.onSubmitError);
      return;
    }
    error.password = getPasswordErrorMessage(password);
    error.email = getEmailErrorMessage(email);
    this.setState({ error, buttonIsDisabled: false });
  };

  render() {
    const { email, password, error } = this.state;
    return (
      <div>
        <h2>Sign Up</h2>
        <Input
          label="Email"
          autoFocus
          type="email"
          autoComplete="email"
          placeholder="yourname@email.com"
          name="email"
          onChange={this.onChange}
          value={email}
          required
          textError={error.email}
        />
        <Input
          label="Password"
          type="password"
          placeholder="....."
          name="password"
          onChange={this.onChange}
          value={password}
          required
          textError={error.password}
        />
        <button
          disabled={this.state.buttonIsDisabled}
          onClick={this.submitHandler}
          className={classNames('btn', 'btn-lg', 'form-control', 'btn-success', {
            'btn-is-disabled-utils': this.state.buttonIsDisabled
          })}
        >
          SIGN UP
          <i className="icon-budicon-461" />
        </button>
      </div>
    );
  }
}

SignupPane.propTypes = {
  onSignup: PropTypes.func.isRequired
};

export default SignupPane;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/SignupPane/SignupPane.js